'use client'

import { useParams } from 'next/navigation'
import { useTranslations } from 'next-intl'

import { contractQueries } from '@/entities/contract'
import { usePrefetchQuery } from '@/shared/api'
import { useDialog } from '@/shared/lib'
import { Button, Dialog, Icon, TextButton } from '@/shared/ui'

import { RefundAccount } from './refund-account'

export const DIALOG = {
  REFUND_ACCOUNT: 'REFUND_ACCOUNT',
} as const

type RefundAccountDialog = keyof typeof DIALOG

export const ShowRefundAccountButton = () => {
  const t = useTranslations()

  const params = useParams()

  const contractId = Number(params?.contractId)

  const { isOpen, open, close } = useDialog()

  const { prefetch } = usePrefetchQuery()

  const closeDialog = (key: RefundAccountDialog) => () => {
    close(key)
  }

  const handleClick = async () => {
    if (!contractId) {
      return
    }

    const { success } = await prefetch(
      contractQueries.guestRefundAccount({ contractId }),
    )

    if (!success) {
      return
    }

    open(DIALOG.REFUND_ACCOUNT)
  }

  return (
    <>
      <TextButton
        size="small"
        weight="normal"
        color="purple"
        onClick={handleClick}
      >
        {t('lease_detail.button.check_refund_information')}
        <Icon name="arrow-right" />
      </TextButton>

      <Dialog.Root
        open={isOpen(DIALOG.REFUND_ACCOUNT)}
        onOpenChange={closeDialog(DIALOG.REFUND_ACCOUNT)}
      >
        <Dialog.Content className="h-[262px] gap-0 p-0">
          <Dialog.Header className="p-6">
            <Dialog.Title className="text-start">
              {t('refund_information.title')}
            </Dialog.Title>
          </Dialog.Header>
          <Dialog.Body className="grow px-6">
            <RefundAccount contractId={contractId} />
          </Dialog.Body>
          <Dialog.Footer className="p-6">
            <Dialog.Close asChild>
              <Button
                type="button"
                variant="solid"
                color="secondary"
                size="large"
                fullWidth
              >
                {t('refund_information.button.close')}
              </Button>
            </Dialog.Close>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Root>
    </>
  )
}
